export default __webpack_public_path__ + "img/DJsRewards-2018_409092.png";